
import css from 'styled-jsx/css';

export default css`.exit-intent-modal {
  width: 100%;

  position: fixed;
  top: 100%;
  z-index: 5;
  transition: transform 0.5s cubic-bezier(0.93, 0.07, 0.27, 0.97);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2), 0 2px 15px rgba(0, 0, 0, 0.3);

  :global(> *) {
    padding: 40px 0 0;
  }

  &.open {
    transform: translateY(-100%);

    transition: transform 0.5s cubic-bezier(0.11, 1.03, 0.21, 0.97);
  }

  &__content {
    display: grid;
    grid-template-columns: 2fr [image] 6fr [content] 6fr 2fr;
    align-items: center;
    max-width: $container-max-width;
    margin: 0 auto;
  }

  &__image {
    grid-column: image;
    box-shadow: 0px 4.68965px 4.68965px rgba(0, 0, 0, 0.25);
    border-radius: 10px 10px 0 0;
    position: relative;
    overflow: hidden;
    align-self: flex-end;
  }
  &__text {
    grid-column: content;
    padding-left: 48px;
    padding-bottom: 40px;

    &__points {
      li {
        margin: 8px 0;

        :global(svg) {
          margin-right: 16px;
          position: relative;
          top: 2px;
        }
      }
    }
  }
  &__header {
    margin-bottom: 16px;
  }
  &__footer {
    margin-top: 32px;
    display: block;
  }

  &__close {
    @include focusable;

    position: absolute;
    top: 1.5rem;
    right: 1.5rem;

    &:focus {
      position: absolute;
    }
  }
}
`